// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 987) return "static/chunks/987-3558bf5c4f4eaef9.js";
	if (chunkId === 769) return "static/chunks/769-b4ba4d0535ce177f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"348":"566bba11f2e0e67e","446":"11954fff39aa677a","475":"430043c21203ab23","702":"76882bc6d6ed3efb","858":"684313714710b4de"}[chunkId] + ".js";
};